const resources = {
  "en": {
    "realTransactions": {
      "title": "📊 Real Transactions — Calendar",
      "summary": {
        "cardTitle": "Actual totals",
        "incomeLabel": "Total Income",
        "expenseLabel": "Total Expense",
        "balanceLabel": "Balance",
        "incomeTag": "+{{amount}}",
        "expenseTag": "-{{amount}}",
        "balanceTagPositive": "+{{amount}}",
        "balanceTagNegative": "-{{amount}}"
      },
      "calendar": {
        "cardTitle": "Actual calendar",
        "unnamedTransaction": "Transaction",
        "expenseTooltipLine": "💸 {{description}} — {{amount}}",
        "incomeTooltipLine": "💵 {{description}} +{{amount}}",
        "transferTooltipLine": "🔄 {{description}} {{amount}}",
        "expenseTag": "-{{amount}}",
        "incomeTag": "+{{amount}}",
        "transferTag": "{{amount}}"
      },
      "errors": {
        "load": "❌ Failed to load real transactions"
      }
    }
  },
  "uk": {
    "realTransactions": {
      "title": "📊 Реальні транзакції — календар",
      "summary": {
        "cardTitle": "Фактичні підсумки",
        "incomeLabel": "Загальний дохід",
        "expenseLabel": "Загальні витрати",
        "balanceLabel": "Баланс",
        "incomeTag": "+{{amount}}",
        "expenseTag": "-{{amount}}",
        "balanceTagPositive": "+{{amount}}",
        "balanceTagNegative": "-{{amount}}"
      },
      "calendar": {
        "cardTitle": "Календар фактичних транзакцій",
        "unnamedTransaction": "Транзакція",
        "expenseTooltipLine": "💸 {{description}} — {{amount}}",
        "incomeTooltipLine": "💵 {{description}} +{{amount}}",
        "transferTooltipLine": "🔄 {{description}} {{amount}}",
        "expenseTag": "-{{amount}}",
        "incomeTag": "+{{amount}}",
        "transferTag": "{{amount}}"
      },
      "errors": {
        "load": "❌ Не вдалося завантажити реальні транзакції"
      }
    }
  }
};

export default resources;
